module.exports.default = {
    ONLINE_BOOKING_BACKEND_V2 : 'https://obbv2demo.shipsy.in',
    PROJECT_X_URL: "https://demodashboardapi.shipsy.in",
    GOOGLE_RECAPTCHA_SITE_KEY: "6Ld8BOQUAAAAAHjZ7AyFHmMUlr1gyXjyXFER9GYX",
    ORGANISATION_LOGO_URL:
      "https://s3-us-west-2.amazonaws.com/shipsy-public-assets/Zajil/Zajil.jpg",
    applicationType: "zajilebooking",
    DEFAULT_PRETTY_NAME: "shipsyflamingo", //org for which you are testing
    organisationId: "shipsyflamingo", //org for which you are testing
    hardcodedDataOrgs: ["ZAJIL"],
    hideAreaCodeOrgs: ["FLOWPL", "epickmeup"],
    apiKey: "8tskcdaRpARZQTu2JCjMAmdBBkpEsk2u",
    RIDER_ONBOARDING_FORM_COMPONENT: {
      ncubate: "DealshareRiderOnboardingForm",
      qwiklogistics: "QwiklogisticsRiderOnboardingForm",
      quiqup: "QuiqupRiderOnboardingForm"
    },
    ORG_LEVEL_ONBOARDING_CONFIG: {
        "dealshare": {
          "AADHAAR_GENERATION_URL": "https://workflow.shipsy.io/webhook/dealshare/generate-aadhaar-otp",
          "AADHAAR_VALIDATION_URL": "https://workflow.shipsy.io/webhook/dealshare/validate-aadhaar-otp",
          "SUBMIT_URL": "https://workflow.shipsy.io/webhook/dealshare/onboard-worker",
          "apiKey": "a9f414a080e283f399051f8217992e",
        },
        "qwiklogistics": {
          AADHAR_CARD_DETAILS_VERIFY_URL: "https://wbdemo.shipsy.io/webhook/aadhar/validate",
          DRIVING_LICENSE_DETAILS_VERIFY_URL: "https://wbdemo.shipsy.io/webhook/drivinglicense/validate",
        },
    }
};

